import React from 'react';
import ForeCast, { WeatherStateId } from './Forecast';
import { LANGUAGE } from '../../../constants';

import * as styles from './ForecastDaily.module.scss';

export interface DailyForecast {
  date: number;
  icon: WeatherStateId;
  minTemp: number;
  maxTemp: number;
}

interface ForecastDailyProps {
  dailyForecasts: Array<DailyForecast>;
}

const ForecastDaily = ({ dailyForecasts }: ForecastDailyProps): React.ReactElement => {
  return (
    <section className={styles.container}>
      {dailyForecasts.map((forecast, index) => (
        <ForeCast
          key={`daily-${index}`}
          id={`daily-${index}`}
          title={new Date(forecast.date * 1000)
            .toLocaleString(LANGUAGE, { weekday: 'short' })
            .replace(/\.$/g, '')}
          icon={forecast.icon}
          animationDelay={index * 100}
          minTemp={forecast.minTemp}
          maxTemp={forecast.maxTemp}
        ></ForeCast>
      ))}
    </section>
  );
};

export default ForecastDaily;
